var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller("categoriesController", [
    "$scope",
    "$rootScope",
    "$window",
    function ($scope, $rootScope, $window) {

        //#region Initialization
        $scope.searchCategory = "";
        // Enable scroll to top on the page
        $scope.$parent.enableScrollToTop = true;

        //#endregion
        $scope.initialize = function (prdType,fp) {
            $scope.prdType = prdType;
            $scope.fp= (fp === 'true');
            if($scope.prdType.toLowerCase() =='stockdesign'){
                $scope.displayPrdType = $scope.fp ? $rootScope.localeVariables.freeDesigns:$rootScope.localeVariables.designs;
            }
            else if($scope.prdType.toLowerCase() =='fontletter'){
                $scope.displayPrdType = $rootScope.localeVariables.designs;
            }
            else if($scope.prdType.toLowerCase() =='font'){
                $scope.displayPrdType =  $rootScope.localeVariables.fonts;
            }
            else{
                $scope.displayPrdType = prdType;
            }
        };

        $scope.initializeCategories = function(){
            if(angular.isDefined($window.allCategories)){
                $scope.allCategories = $window.allCategories;
            }
        }
    }
]);
